export async function delay(seconds: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}

export function getTimeSince(date: Date): string {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (hours > 0) {
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (minutes > 0) {
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else {
    return `${seconds} second${seconds !== 1 ? "s" : ""} ago`;
  }
}

export function formatDateWithTimezone(
  dateString: Date,
  locale: string
): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "shortOffset",
  }).format(date);
}

export function formatTimePassed(date: string): string {
  const { t } = useI18n();
  const currentDate = new Date();
  const fromDate = new Date(date);
  const diffInMinutes = Math.floor(
    (currentDate.getTime() - fromDate.getTime()) / 1000 / 60
  );
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);
  const diffInWeeks = Math.floor(diffInDays / 7);
  const diffInMonths = Math.floor(diffInDays / 30);

  if (diffInMinutes < 60) {
    return new Intl.DateTimeFormat([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(fromDate);
  } else if (diffInHours < 24) {
    return `${diffInHours} ${t("main.countDown.hour", diffInHours)} ${t(
      "main.countDown.ago"
    )}`;
  } else if (diffInDays < 8) {
    return `${diffInDays} ${t("main.countDown.day", diffInDays)} ${t(
      "main.countDown.ago"
    )}`;
  } else if (diffInWeeks <= 4) {
    return `${diffInWeeks} ${t("main.countDown.week", diffInWeeks)} ${t(
      "main.countDown.ago"
    )}`;
  } else {
    return `${diffInMonths} ${t("main.countDown.month", diffInMonths)} ${t(
      "main.countDown.ago"
    )}`;
  }
}
